import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_31: DocMigration = {
  maxSchemaVersion: "0.0.31",
  apply(json: any) {
    if (json.viewerFilter) {
      const viewerFilter = json.viewerFilter;
      if (!viewerFilter.hasOwnProperty("stair")) {
        viewerFilter["stair"] = false;
      }
    }

    return json;
  },
};

export default migration_0_0_31;
